/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  appName: 'Global Forecast System',
  appVersion: '8.2.0',
  appVersionCodename: 'v8.2.0',
  baseApiUrl: '@@{baseApiUrl}@@',
  buildNumber: '0',
  environmentName: '@@{environmentName}@@',
  apiMap: {},
  appLauncherUrls: {
    repo: 'https://link.gm.com/fabric-starter-repo'
  },
  auth: {
    issuer: 'https://login.microsoftonline.com/@@{tenantId}@@/v2.0',
    clientId: '@@{clientId}@@',
    redirectUri: location.origin,
    responseType: 'code',
    scope: 'openid profile email offline_access @@{clientId}@@/.default',
    showDebugInformation: true,
    // turn off validation that discovery document endpoints start with the issuer url defined above
    strictDiscoveryDocumentValidation: false
  },
  message: 'Hello, localhost!'
};
